<template>
  <div class="page-onlineform">
    <div class="section section-lead">
      <v-container>
        <div class="text-end mr-4">
          <img src="/static/icon/icon_novice.png" height="24" :style="{ 'vertical-align': 'bottom' }" /><a
            download
            href="/static/manual/manual_onlineform.pdf"
            >{{ $t('page.onlineform.manual_link') }} (PDF)</a
          >
        </div>
        <h1 class="ttl-lg--center">
          <span class="ttl-lg__text">{{ $t('menu.onlineform') }}</span>
        </h1>
        <p v-if="onlineform.has_signing" class="lead-text pre-line">
          {{ $t('page.onlineform_introduction.lead') }}
        </p>
      </v-container>
    </div>

    <div class="section section-step">
      <v-container>
        <h2 class="ttl-md--center">
          <span class="ttl-circle ttl-md__text">
            {{ $t('page.onlineform_introduction.application_flow') }}
          </span>
        </h2>
        <ul class="lst-step mb-6">
          <li class="lst-step__item">
            <div class="box-step">
              <img
                class="box-step__image"
                src="/static/online-form/img_step_apply_form.png"
                srcset="/static/online-form/img_step_apply_form@2x.png 2x"
              />
              <div class="box-step__title">
                <span class="txt-lg txt-bold">{{ $t('page.onlineform_introduction.application_flow_input') }}</span>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_signing" class="lst-step__item">
            <div class="box-step">
              <img
                class="box-step__image"
                src="/static/online-form/img_step_scan.png"
                srcset="/static/online-form/img_step_scan@2x.png 2x"
              />
              <div class="box-step__title">
                <span class="txt-lg txt-bold">{{ $t('page.onlineform_introduction.application_flow_sign') }}</span>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_payment" class="lst-step__item">
            <div class="box-step">
              <img
                class="box-step__image"
                src="/static/online-form/img_step_creditcard.png"
                srcset="/static/online-form/img_step_creditcard@2x.png 2x"
              />
              <div class="box-step__title">
                <span class="txt-lg txt-bold">{{ $t('page.onlineform_introduction.application_flow_pay') }}</span>
              </div>
            </div>
          </li>
          <li class="lst-step__item">
            <div class="box-step">
              <img
                class="box-step__image"
                src="/static/online-form/img_step_deliver.png"
                srcset="/static/online-form/img_step_deliver@2x.png 2x"
              />
              <div class="box-step__title">
                <span class="txt-lg txt-bold pre-line">{{
                  $t('page.onlineform_introduction.application_flow_receive')
                }}</span>
              </div>
            </div>
          </li>
        </ul>
        <p v-if="onlineform.has_signing" class="step-text pre-line">
          {{ $t('page.onlineform_introduction.application_flow_note') }}
        </p>
      </v-container>
    </div>

    <div v-if="onlineform.has_signing || onlineform.has_payment || onlineform.pre_notice_title != '' || onlineform.pre_notice_body != ''" class="section section-prep">
      <v-container>
        <h2 class="ttl-md--center">
          <span class="ttl-circle ttl-md__text">
            {{ $t('page.onlineform_introduction.what_you_need') }}
          </span>
        </h2>
        <ul class="lst-column">
          <li v-if="onlineform.pre_notice_title.trim() != '' || onlineform.pre_notice_body.trim() != ''" class="lst-column__item mb-lg">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_general.png"
                srcset="/static/online-form/img_prep_general@2x.png 2x"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ onlineform.pre_notice_title }}</span>
              </div>
              <div class="box-prep__content onlineformMavon">
                <mavon-editor
                  v-model="onlineform.pre_notice_body"
                  :language="$store.getters.getLocale"
                  :external-link="mavonEditor.externalLink"
                  :subfield="false"
                  :editable="false"
                  :toolbars-flag="false"
                  :box-shadow="false"
                  default-open="preview"
                  preview-background="rgb(241, 241, 244)"
                ></mavon-editor>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_signing" class="lst-column__item mb-lg">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_mynumber.png"
                srcset="/static/online-form/img_prep_mynumber@2x.png 2x"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_mynumber') }}</span>
              </div>
              <div class="box-prep__content">
                <ul class="lst-disc">
                  <li>{{ $t('page.onlineform_introduction.what_you_need_mynumber_item1') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_mynumber_item2') }}</li>
                  <li>
                    {{ $t('page.onlineform_introduction.what_you_need_mynumber_item3_1') }}
                    <ul class="lst-disc">
                      <li>{{ $t('page.onlineform_introduction.what_you_need_mynumber_item3_2') }}</li>
                      <li>{{ $t('page.onlineform_introduction.what_you_need_mynumber_item3_3') }}</li>
                    </ul>
                    {{ $t('page.onlineform_introduction.what_you_need_mynumber_item3_4') }}
                  </li>
                  <li>
                    {{ $t('page.onlineform_introduction.what_you_need_mynumber_item4') }}
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_signing" class="lst-column__item mb-lg">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_pass.png"
                srcset="/static/online-form/img_prep_pass@2x.png 2x"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_password') }}</span>
              </div>
              <div class="box-prep__content">
                <ul class="lst-disc">
                  <li>{{ $t('page.onlineform_introduction.what_you_need_password_item1') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_password_item2') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_password_item3') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_password_item4') }}</li>
                </ul>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_signing" class="lst-column__item mb-lg">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_pass02.png"
                srcset="/static/online-form/img_prep_pass02@2x.png 2x"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_pin') }}</span>
              </div>
              <div class="box-prep__content">
                <ul class="lst-disc">
                  <li>{{ $t('page.onlineform_introduction.what_you_need_pin_item1') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_pin_item2') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_pin_item3') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_pin_item4') }}</li>
                </ul>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_signing" class="lst-column__item mb-lg">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_sp.png"
                srcset="/static/online-form/img_prep_sp@2x.png 2x"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_smartphone') }}</span>
              </div>
              <div class="box-prep__content">
                <ul class="lst-disc">
                  <li>{{ $t('page.onlineform_introduction.what_you_need_smartphone_item1') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_smartphone_item2') }}</li>
                  <li>{{ $t('page.onlineform_introduction.what_you_need_smartphone_item3') }}</li>
                </ul>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_signing" class="lst-column__item mb-lg">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_digi_app.png"
                srcset="/static/online-form/img_prep_digi_app@2x.png 2x"
                :style="{ width: $vuetify.breakpoint.mobile ? '50%' : '70%' }"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_app') }}</span>
              </div>
              <div class="box-prep__content">
                <p>{{ $t('page.onlineform_introduction.what_you_need_app_item1') }}</p>
                <div class="box-app mb-3">
                  <div class="box-app__title">
                    <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_app_item2') }}</span>
                  </div>
                  <ul class="lst-appDl">
                    <li class="lst-appDl__item">
                      <a
                        target="_blank"
                        href="https://apps.apple.com/jp/app/%E3%83%9E%E3%82%A4%E3%83%8A%E3%82%A2%E3%83%97%E3%83%AA-%E6%97%A7%E3%83%9E%E3%82%A4%E3%83%8A%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB%E3%82%A2%E3%83%97%E3%83%AA/id1476359069"
                      >
                        <img
                          class="lst-appDl__banner"
                          src="/static/common/banner_app_store.png"
                          :alt="$t('page.onlineform_introduction.what_you_need_app_item2_iphone')"
                        />
                      </a>
                    </li>
                    <li class="lst-appDl__item">
                      <a
                        target="_blank"
                        :href="
                          'https://play.google.com/store/apps/details?id=jp.go.cas.mpa&hl=' +
                          $store.getters.getLocale
                        "
                      >
                        <img
                          class="lst-appDl__banner"
                          src="/static/common/banner_google_play.png"
                          :alt="$t('page.onlineform_introduction.what_you_need_app_item2_android')"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="box-app">
                  <div class="box-app__title">
                    <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_app_item3') }}</span
                    ><br /><small class="caption-md caption-md--grey">{{
                      $t('page.onlineform_introduction.what_you_need_app_item3_note')
                    }}</small>
                  </div>
                  <v-btn class="btn-secondary--lg" href="https://services.digital.go.jp/mynaapp/" target="_blank">
                    <span class="btn-secondary__text">{{
                      $t('page.onlineform_introduction.what_you_need_app_item3_usage')
                    }}</span>
                    <img class="btn-secondary__icon" src="/static/icon/icon_new_window_kgreen600.svg" alt="" />
                  </v-btn>
                </div>
                <p class="mt-3"><a href="https://services.digital.go.jp/mynaapp/system-requirements/" target="_blank">{{ $t('page.onlineform_introduction.what_you_need_app_item4') }}</a><v-icon>open_in_new</v-icon></p>
              </div>
            </div>
          </li>
          <li v-if="onlineform.has_payment" class="lst-column__item">
            <div class="box-prep">
              <img
                class="box-prep__image"
                src="/static/online-form/img_prep_creditcard.png"
                srcset="/static/online-form/img_prep_creditcard@2x.png 2x"
              />
              <div class="box-prep__title">
                <span class="ttl-xxs__text">{{ $t('page.onlineform_introduction.what_you_need_creditcard') }}</span>
              </div>
              <div class="box-prep__content">
                <ul class="lst-disc">
                  <li>{{ $t('page.onlineform_introduction.what_you_need_creditcard_item1') }}</li>
                  <li>
                    {{ $t('page.onlineform_introduction.what_you_need_creditcard_item2') }}<br />
                    <img class="box-prep__cards mt-2" src="/static/online-form/img_cards.png" />
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </v-container>
    </div>

    <div class="section section-check">
      <v-container>
        <h2 class="ttl-md--center">
          <span class="ttl-circle ttl-md__text">
            {{ $t('page.onlineform_introduction.before_you_apply') }}
          </span>
        </h2>
        <p class="lead-text pre-line mb-8">
          {{ $t('page.onlineform_introduction.before_you_apply_lead') }}
        </p>
        <v-form ref="form" v-model="valid" @submit.prevent>
          <div class="box-form">
            <div class="box-form__inner">
              <div class="frm-block">
                <v-row no-gutters>
                  <v-col v-if="onlineform.pre_checkbox != ''" cols="12">
                    <v-checkbox v-model="params.checkbox1" class="input-checkbox" :rules="[rules.checked]">
                      <template #label>
                        <span>{{ onlineform.pre_checkbox }}</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="onlineform.has_signing" cols="12">
                    <v-checkbox v-model="params.checkbox2" class="input-checkbox" :rules="[rules.checked]">
                      <template #label>
                        <span>
                          {{ $t('page.onlineform_introduction.before_you_apply_mynumber') }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="onlineform.has_signing" cols="12">
                    <v-checkbox v-model="params.checkbox3" class="input-checkbox" :rules="[rules.checked]">
                      <template #label>
                        <span>
                          {{ $t('page.onlineform_introduction.before_you_apply_password') }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="onlineform.has_signing" cols="12">
                    <v-checkbox v-model="params.checkbox4" class="input-checkbox" :rules="[rules.checked]">
                      <template #label>
                        <span>
                          {{ $t('page.onlineform_introduction.before_you_apply_pin') }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="onlineform.has_payment" cols="12">
                    <v-checkbox v-model="params.checkbox5" class="input-checkbox" :rules="[rules.checked]">
                      <template #label>
                        <span>
                          {{ $t('page.onlineform_introduction.before_you_apply_creditcard') }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col v-if="onlineform.has_signing" cols="12">
                    <v-checkbox v-model="params.checkbox6" class="input-checkbox" :rules="[rules.checked]">
                      <template #label>
                        <span>
                          {{ $t('page.onlineform_introduction.before_you_apply_app') }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <!-- 以下のボタンは開発側で仮追加 -->
                  <v-col>
                    <v-btn
                      color="primary"
                      class="btn-primary btn-block"
                      :loading="loading"
                      style="margin: auto"
                      @click="moveToForm()"
                    >
                      <span class="btn-primary__text">{{ $t('page.onlineform_introduction.proceed_to_form') }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-form>
      </v-container>
    </div>
  </div>
</template>

<script>
import mavonEditor from 'mavon-editor'
import Vue from 'vue'
import Validation from '@/mixins/Validation'

Vue.use(mavonEditor)

export default {
  mixins: [Validation],

  data() {
    return {
      loading: false,
      valid: true,
      error: false,
      onlineform: {
        has_signing: false,
        has_payment: false,
        pre_notice_title: '',
        pre_notice_body: '',
        pre_checkbox: '',
      },

      params: {
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        checkbox4: false,
        checkbox5: false,
        checkbox6: false,
      },

      mavonEditor: {
        externalLink: {
          markdown_css: function () {
            return '/static/css/markdown/github-markdown.min.css'
          },
          hljs_js: function () {
            return '/static/js/highlightjs/highlight.min.js'
          },
          katex_css: function () {
            return '/static/css/katex/katex.min.css'
          },
          katex_js: function () {
            return '/static/js/katex/katex.min.js'
          },
        },
      },
    }
  },

  watch: {
    '$route.params.onlineform_id': {
      handler() {
        this.loadOnlineform()
      },
    },
  },

  created() {
    this.loadOnlineform()
  },

  methods: {
    /**
     * オンライン申請情報を読み込む。
     */
    async loadOnlineform() {
      this.loading = true
      let query = ''
      if (this.$route.query.key && this.$route.query.key.match(/^[0-9a-f]+$/)) {
        query = 'key=' + this.$route.query.key + '&'
      }
      const res = await this.$axios.get('/api/onlineform/' + this.$route.params.onlineform_id + '?' + query + Date.now())
      if (res.data) {
        this.onlineform = res.data
        if (!this.onlineform.has_signing && !this.onlineform.has_payment && this.onlineform.pre_notice_title == '' && this.onlineform.pre_notice_body == '' && this.onlineform.pre_checkbox == '') {
          this.$router.push({ name: 'OnlineformForm', params: { onlineform_id: this.onlineform.id }, query: { key: this.$route.query.key } })
        }
      }
      this.loading = false
    },

    moveToForm() {
      this.error = !this.$refs.form.validate()
      if (!this.error) {
        this.$router.push({ name: 'OnlineformForm', params: { onlineform_id: this.onlineform.id }, query: { key: this.$route.query.key } })
      }
    },
  },
}
</script>
<style lang="css">
.onlineformMavon ul li {
  list-style: disc;
}
</style>
